<script lang="ts">
  import { orgGlobe, orgUser } from "@nrk/origo";
  import { Mimir } from "bildebanken-model";
  import { user, getCurrentUser } from "services/api";
  import type { MimirSearchHit } from "services/searchHit";
  import { getDetailLink } from "state/page";
  import { createMetadataQuery } from "state/queries/mimir";
  import { getThumbnailUrlFromMimirSearchHit } from "state/thumbnails";
  import { onMount } from "svelte";

  export let item: MimirSearchHit;
  export let disabled = false;

  const detailPath = getDetailLink(item.id);
  const currentUserId = getCurrentUser().id;

  $: query = createMetadataQuery(item.id, "Bildebanken");
  $: result = $query;
  $: title = result.data?.title ?? "Ingen tittel";
  $: published = result.data?.metadata?.publicId !== undefined;

  let owner: Mimir.User | undefined = undefined;

  onMount(async () => {
    if (disabled) {
      owner = await user(item.createdBy);
    }
  });
</script>

<li class="wrapper" data-testid="item-to-be-deleted" class:disabled>
  <div>
    <a href={detailPath} target="_blank" rel="noreferrer">
      <img src={getThumbnailUrlFromMimirSearchHit(item)} alt="" /><span>{title}</span>
    </a>
  </div>

  {#if published && item.createdBy === currentUserId}
    <a href={detailPath} target="_blank" rel="noreferrer" class="published">
      {@html orgGlobe} Publisert
    </a>
  {:else if disabled && owner}
    <span class="owner">
      {@html orgUser}
      <a class="name-link" href="mailto:{owner.email}">{owner.givenName} {owner.familyName}</a>
    </span>
  {/if}
  <slot />
</li>

<style>
  li {
    list-style: none;
    margin-bottom: var(--org-small);
    display: flex;
    gap: var(--org-small);
    align-items: center;
    justify-content: space-between;
  }

  a:hover {
    text-decoration: underline;
    filter: brightness(1.07);
  }

  img {
    display: inline;
    width: 60px;
    height: 40px;
    object-fit: cover;
    margin-right: var(--org-small);
  }

  .disabled {
    opacity: 0.5;
  }

  .published :global(svg) {
    font-size: 0.75rem;
    margin-bottom: 2px;
  }

  .owner :global(svg) {
    font-size: 0.65rem;
    margin-bottom: 4px;
  }
</style>
